import { API_URL } from '../config';
import { Event } from '../models/Event';
import { Match } from '../models/Tournament';
import { transformDate } from '../utils/Dates';
import { isUnathorized } from '../utils/ServiceUtil';
import { GroupSoccerTeam } from './GroupService';
import { buildHeaders } from './headers';

export interface MatchEditorDto extends MatchDto {
  soccerTeam1?: GroupSoccerTeam;
  soccerTeam2?: GroupSoccerTeam;
  formula1?: string;
  formula2?: string;
  locked: boolean;
  modified: boolean;
}

export interface MatchDto {
  id: number;
  groupId: number;
  soccerTeam1Id: number;
  soccerTeam2Id: number;
  soccerTeam1Goals?: number;
  soccerTeam2Goals?: number;
  matchDate?: string;
  venue?: string;
  isFinished?: boolean;
  formula?: string;
}

export const getMatch = async (apiKey: string, matchId: string): Promise<MatchDto> => {
  const response = await fetch(`${API_URL}/api/Match/${matchId}`, {
    headers: buildHeaders(apiKey),
  });
  isUnathorized(response);
  if (response.ok) {
    const data = await response.json();
    return data;
  } else {
    return Promise.reject(response);
  }
};

export const postMatchesFromDto = async (apiKey: string, matches: MatchDto[]): Promise<MatchDto[]> => {
  matches.forEach((match) => {
    match.matchDate = match.matchDate !== undefined ? transformDate(match.matchDate) : match.matchDate;
  });
  const response = await fetch(`${API_URL}/api/match`, {
    method: 'POST',
    body: JSON.stringify(matches),
    headers: buildHeaders(apiKey),
  });
  if (response.ok) {
    const data = await response.json();
    return data;
  } else {
    return Promise.reject(response);
  }
};

export const fetchMatches = async (apiKey: string, groupId: number): Promise<MatchDto[]> => {
  const response = await fetch(`${API_URL}/api/Group/${groupId}/matches`, {
    headers: buildHeaders(apiKey),
  });
  isUnathorized(response);
  if (response.ok) {
    const data = await response.json();
    return data;
  } else {
    return Promise.reject(response);
  }
};

export const deleteMatch = async (apiKey: string, matchId: number) => {
  const response = await fetch(`${API_URL}/api/match/` + matchId, {
    method: 'DELETE',
    headers: buildHeaders(apiKey),
  });
  if (response.ok) {
    return response.ok;
  } else {
    return Promise.reject(response);
  }
};

export const postEvent = async (apiKey: string, event: Event): Promise<Event> => {
  const response = await fetch(`${API_URL}/api/match/${event.matchId}/event`, {
    method: 'POST',
    body: JSON.stringify(event),
    headers: buildHeaders(apiKey),
  });
  if (response.ok) {
    const data = await response.json();
    return data;
  } else {
    return Promise.reject(response);
  }
};

export const fetchEvents = async (apiKey: string, matchId: any): Promise<Event[]> => {
  const response = await fetch(`${API_URL}/api/match/${matchId}/event`, {
    method: 'GET',
    headers: buildHeaders(apiKey),
  });
  if (response.ok) {
    const data = await response.json();
    return data;
  } else {
    return Promise.reject(response);
  }
};

export const updateScore = async (apiKey: string, matchId: number, team1Goals: number, team2Goals: number): Promise<Match> => {
  const scoreUpdate = {
    soccerTeam1Goals: team1Goals,
    soccerTeam2Goals: team2Goals,
  };
  const response = await fetch(`${API_URL}/api/match/${matchId}/score`, {
    method: 'POST',
    body: JSON.stringify(scoreUpdate),
    headers: buildHeaders(apiKey),
  });
  if (response.ok) {
    const data = await response.json();
    return data;
  } else {
    return Promise.reject(response);
  }
};
